import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('admin_token') || '',
    adminInfo: (() => {
      try {
        const adminInfoStr = localStorage.getItem('admin_info');
        if (adminInfoStr && adminInfoStr !== 'null' && adminInfoStr !== 'undefined') {
          return JSON.parse(adminInfoStr);
        }
      } catch (e) {
        console.error('解析admin_info失败:', e);
      }
      return { username: '', role: '' };
    })(),
    sidebarCollapsed: false
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('admin_token', token)
    },
    SET_ADMIN_INFO(state, adminInfo) {
      state.adminInfo = adminInfo
      localStorage.setItem('admin_info', JSON.stringify(adminInfo))
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.adminInfo = {}
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_info')
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    }
  },
  actions: {
    login({ commit }, { token, adminInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_ADMIN_INFO', adminInfo)
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    },
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    adminName: state => {
      if (!state.adminInfo || typeof state.adminInfo !== 'object') {
        return ''
      }
      return state.adminInfo.username || ''
    }
  }
})